module.exports = __webpack_public_path__ + "static/img/7.1a69a3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shao/7.jpg
// module id = 2eZK
// module chunks = 1